<script>
    let className='';
    export {className as class};
    export let color = 'currentColor';
    export let icon;
    export let size=22;
    export let title='';

    $: src = `/icons/${icon}${color && color !== 'currentColor' ? '-' + color.replace('#', '').toLowerCase() : ''}.svg`;
</script>

<img on:click class={className} {src} width={size} height={size} alt={title} {title}>